/**
 * Gap marker — shared component #4 (README "Shared components" list).
 * Source: Quote Flow Components.dc.html §1c ("middle prominence" — the one
 * the prototype actually uses, per the README).
 *
 * Not consumed by anything in this run: its only consumer is S8 (comparison
 * view), which is explicitly out of scope. Built now as shared-component
 * scope required it; will be wired up when S8 ships.
 */
interface GapMarkerProps {
  gaps: string[];
  onAskAboutThis?: () => void;
  className?: string;
}

const GapMarker = ({
  gaps,
  onAskAboutThis,
  className = '',
}: GapMarkerProps) => {
  const hasGaps = gaps.length > 0;

  return (
    <div
      className={`rounded-[10px] border border-gray-100 bg-[#FAFAF9] px-3.5 py-3 ${className}`}
    >
      <div className="flex items-center gap-1.5 mb-2">
        <p className="text-[10.5px] font-semibold tracking-wider uppercase text-gray-400">
          Not answered
        </p>
        <span className="text-[10.5px] text-gray-400">
          &middot; {hasGaps ? `${gaps.length} open` : 'nothing missing'}
        </span>
      </div>

      {hasGaps ? (
        <>
          <div className="space-y-1">
            {gaps.map((gap) => (
              <div key={gap} className="flex items-start gap-2">
                <span className="w-[15px] h-[15px] mt-0.5 rounded border border-dashed border-gray-400 shrink-0" />
                <span className="text-[13px] leading-[1.45] text-[#4B5563]">
                  {gap}
                </span>
              </div>
            ))}
          </div>
          {onAskAboutThis && (
            <button
              type="button"
              onClick={onAskAboutThis}
              className="mt-1.5 text-[12.5px] text-[#317690] underline"
            >
              Ask about this
            </button>
          )}
        </>
      ) : (
        <div className="flex items-center gap-2 text-[12.5px] text-gray-500">
          <span className="text-[#16A34A]">&#10003;</span>
          <span>Answered everything the others were asked.</span>
        </div>
      )}
    </div>
  );
};

export default GapMarker;
